import { postReq } from '../infra/http';
import { getReq, createUrl } from "@/infra/http";
import { PagedResponseModel, BaseResponseModel, PaginatedSelectModel } from "@/models/core.model";
import { SubscriptionCode, subscriptionCodeFromJson, SubscriptionCodePaginationFilterRequest, UpsertSubscriptionCode } from '@/models/subscription-code.model';
import { SubscriptionDurationList, SubscriptionTierList } from '@/models/subscription-plan.model';

export const getPagedSubscriptionCodes = async (input: SubscriptionCodePaginationFilterRequest): Promise<PagedResponseModel<SubscriptionCode>> => {
  return await getReq(createUrl("a/Subscription/Code/PagedData"),
    { params: input }
  ).then((res: any) => ({
      ...res.data,
      result: res.data.result.map(itm => subscriptionCodeFromJson(itm))
    }));
};

export const getSubscriptionCodesLookup = async (keyword?: string, page?: number): Promise<PaginatedSelectModel> => {
  const model: SubscriptionCodePaginationFilterRequest = {
    pageNumber: page ?? 1,
    pageSize: 100,
    keyword: keyword,
    isAscending: false,
  };
  return await getPagedSubscriptionCodes(model).then(data => 
    ({ 
      data: data.result.map(itm => ({ 
        value: itm.id, 
        label: `Code: ${itm.code} (${SubscriptionTierList.find(t => t.value === itm.subscriptionPlan?.tier)?.label ?? "Unknown Tier"} - ${SubscriptionDurationList.find(d => d.value === itm.subscriptionPlan?.duration)?.label ?? "Unknown Duration"})`
      })),
      isLastPage: data.pageNumber >= data.totalPages,
    })
  );
};

export const getSubscriptionCode = async (id: number): Promise<BaseResponseModel<SubscriptionCode>> => {
  return await getReq(createUrl(`a/Subscription/Code/GetById/${id}`),
  ).then((res: any) => ({
      ...res.data,
      result: subscriptionCodeFromJson(res.data.result)
    }));
};

export const upsertSubscriptionCode = async (input: UpsertSubscriptionCode): Promise<BaseResponseModel<SubscriptionCode>> => {
  return await postReq(createUrl("a/Subscription/Code/Upsert"),
    input
  ).then((res: any) => ({
      ...res.data,
      result: subscriptionCodeFromJson(res.data.result)
    }));
};
